import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;
const API_URL_TOOL = process.env.VUE_APP_BASE_API_URL_OSINT;



class NewsService {
    SearchnewsInfo(keyword) {
        const data = { keyword }; // Ensure the data is structured as { keyword: "string" }
        return axios.post('https://news.testingnow.site/api/news/osint/search', data, { headers: authHeader() });
    }
    // SearchnewsInfo(data) {
    //     return axios.post(API_URL_TOOL + 'news/search-news2/', data, { headers: authHeader() });
    // }
    NewsInfo() {
        return axios.get(API_URL+'news', { headers: authHeader() });
    }
    newsTarget(id) {
        return axios.get(API_URL+'news-target/'+id, { headers: authHeader() });
    }
    getNewsInfoDetail(id) {
        return axios.get(API_URL+'news/'+id, { headers: authHeader() });
    }
    createNewsInfo(data) {
        return axios.post(API_URL+'news', data, { headers: authHeader() });
    }
    deleteNewsInfo(id) {
        return axios.delete(API_URL+'news/'+id, { headers: authHeader() });
    }
    newsBulkNewsInfo(data) {
        return axios.post(API_URL+'news/bulk-delete', data, { headers: authHeader() });
    }
    
    SaveNews(data) {
        return axios.post(API_URL + 'news', data, { headers: authHeader() });
    }
    getNewsByID(id) {
        return axios.get(API_URL + 'news-target/'+id, { headers: authHeader() });
    }
    deleteNewsTarget(id){
        return axios.delete(API_URL + 'news-target-delete/'+id, { headers: authHeader() });
    }

    newsDelete(id){
        return axios.delete(API_URL + 'news/'+id, { headers: authHeader() });
    }

    newsBulkDelete(data) {
        return axios.post(API_URL+'news/bulk-delete', data, { headers: authHeader() });
    }
    
    newsSource(data){
        return axios.post(API_URL_TOOL + 'news/source/', data, { headers: authHeader() });
    }

    newsSentiment(data){
        return axios.post(API_URL_TOOL + 'news/sentiment-analys/', data, { headers: authHeader() });
    }
    
    newsSentimentFilter(data){
        return axios.post(API_URL_TOOL + 'news/sentiment-filter/', data, { headers: authHeader() });
    }

    getNewsHoax(data){
        return axios.post(API_URL+'news/latest-hoax', data, { headers: authHeader() });
    }

    cekHoax(data){
        return axios.post(API_URL+'news/check-hoax', data, { headers: authHeader() });
    }
}

export default new NewsService();
